import { createContext } from "react";

export const SelectOptions = createContext();
